import defaultV2Client from '@/plugins/axios/defaultV2Client'
import qs from 'query-string'

export default {
  getWholesalerDetail(uuid) {
    return defaultV2Client.get(`/wholesalers/${uuid}?${qs.stringify({ isAccountVisible: true })}`)
  },
}
